module.exports = __webpack_public_path__ + "assets/img/hand-dice.d438fee6.png";